import { render, staticRenderFns } from "./MobileAppLinks.vue?vue&type=template&id=13f95854"
import script from "./MobileAppLinks.vue?vue&type=script&lang=js"
export * from "./MobileAppLinks.vue?vue&type=script&lang=js"
import style0 from "./MobileAppLinks.vue?vue&type=style&index=0&id=13f95854&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports